import { Component, EventEmitter, Input, Output } from '@angular/core';
import { V3InfoButton } from '../v3-info-button/v3-info-button';
import { TimeAgo } from '../time-ago/time-ago';

// FinnetWeb desktop's "subpage structure" — one accent-card container wrapping a title +
// timestamp + info button header (with a divider underneath) and projected content. Currently used by
// V3CompanyProfile's finnetWeb-desktop branch; meant for reuse by every ported FinnetWeb
// subpage except the main overview once this design is finalized — see v3-root/CLAUDE.md.
@Component({
  selector: 'app-v3-finnet-subpage-card',
  templateUrl: './v3-finnet-subpage-card.html',
  styleUrl: './v3-finnet-subpage-card.scss',
  standalone: true,
  imports: [V3InfoButton, TimeAgo],
})
export class V3FinnetSubpageCard {
  @Input() title = '';
  // The tab's overview-card timestamp; none when null.
  @Input() updatedAt: Date | null = null;
  @Input() showInfoButton = true;
  @Output() infoClicked = new EventEmitter<void>();
}
